const baseAdvertUrl = "Advert"
const baseCategoryUrl = "Category"
const baseGeneralyUrl = "General"
const basePaymentUrl = "Payment"
const baseContractUrl = "Contract"


  const endpoints = {
   createAdvert:`${baseAdvertUrl}/Create`,
   editAdvert:`${baseAdvertUrl}/Edit`,
   patchAdvert:`${baseAdvertUrl}/Patch`,
   getCategoryFilter:`${baseCategoryUrl}/Filter`,
   getCategoryTreeWithChildren:`${baseCategoryUrl}/GetCategoryTreeByUrl`,
   getCategoryTreeWithChildrenById:`${baseCategoryUrl}/GetCategoryWithChildren`,
   getAdvertCategoryDetails:`${baseCategoryUrl}/GetAllCategoryRouteById`,
   getPackages:`${baseGeneralyUrl}/GetPackages`,
   getDopings:`${baseGeneralyUrl}/GetDopings`,
   getOptionsByCategoryId:`${baseCategoryUrl}/GetCategoryOptions`,
   addImageInAdvert:`${baseAdvertUrl}/AddImageByAdvert`,
   getMediaByAdvert:`${baseAdvertUrl}/GetMediaByAdvert`,
   addMediaByAdvert:`${baseAdvertUrl}/AddMediaByAdvert`,
   updateMediaByAdvert:`${baseAdvertUrl}/updateMediaByAdvert`,
   deleteMediaByAdvert:`${baseAdvertUrl}/DeleteMediaByAdvert`,
   addContactTypeByAdvert:`${baseAdvertUrl}/AddContactTypeByAdvert`,
   createPayment:`${basePaymentUrl}/Create`,
   getInstallment:`${basePaymentUrl}/GetBankInfo`,
   getDocumentByAdvert:`${baseAdvertUrl}/GetDocumentByAdvert`,
   addDocumentByAdvert:`${baseAdvertUrl}/AddDocumentByAdvert`,
   deleteDocumentByAdvert:`${baseAdvertUrl}/DeleteDocumentByAdvert`,
   EIDSAuthenticateUser:`${baseGeneralyUrl}/EidsAuthenticateUser`,
   EidsTasinmazValidate:`${baseGeneralyUrl}/EidsTasinmazValidate`,
   EidsAracValidate:`${baseGeneralyUrl}/EidsAracValidate`,
   updateFaultyPieceAttr:`${baseAdvertUrl}/UpdateFaultyPieceAttr`,
   getContractTypeById:`${baseContractUrl}/GetByContractTypeId`,
   getCategoryTreeWithTopCategoryByUrlAsync:`${baseCategoryUrl}/GetCategoryTreeWithTopCategoryByUrlAsync`
   
  };
  export default endpoints;
  